import {
  CellStyleModule,
  ClientSideRowModelApiModule,
  ColumnApiModule,
  Module,
  PaginationModule,
  PinnedRowModule,
  QuickFilterModule,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowStyleModule,
  ScrollApiModule,
  TooltipModule,
} from 'ag-grid-community';

/**
 * The ag-grid modules the app registers, shared with `test-setup.ts` so specs run against the same
 * set. A grid API function whose module is missing does nothing in production beyond a one-time
 * console error #200.
 */
export const AG_GRID_MODULES: Module[] = [
  CellStyleModule,
  ClientSideRowModelApiModule,
  ColumnApiModule,
  PaginationModule,
  PinnedRowModule,
  QuickFilterModule,
  RenderApiModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowStyleModule,
  ScrollApiModule,
  TooltipModule,
];
